import { render, staticRenderFns } from "./AnnouncementModal.vue?vue&type=template&id=a52634be&scoped=true"
import script from "./AnnouncementModal.vue?vue&type=script&lang=js"
export * from "./AnnouncementModal.vue?vue&type=script&lang=js"
import style0 from "./AnnouncementModal.vue?vue&type=style&index=0&id=a52634be&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a52634be",
  null
  
)

export default component.exports